<template>
  <div class="custom-timepicker">
    <label v-if="title" class="label">{{ title }}</label>

    <v-icon class="timepicker-icon" color="#4D9FEB" @click="onClick">
      schedule
    </v-icon>

    <time-picker
      v-model="selectedDate"
      placeholder="Select time"
      format="HH:mm"
      :clearable="false"
      :picker-options="{timeRange}"
      :disabled='disabled'
      class="original-picker"
      ref="timepicker"
    />
  </div>
</template>

<script>
import moment from 'moment';

import { TimePicker } from 'element-ui';
import vClickOutside from 'v-click-outside';
import { formatSingleDateToDatepicker, formatRangeDateToDatepicker } from '@/utils/dateUtils';

export default {
  name: 'CustomTimepicker',
  components: {
    TimePicker,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: [String, Array],
      required: true,
    },
    selectableRange: {
      type: [String, Array],
    },
    title: {
      type: String,
    },
    format: {
      type: String,
    },
  },
  computed: {
    timeRange() {
      return this.selectableRange || '';
    },
    selectedDate: {
      get() {
        if (this.value) {
          const [hours, minutes] = this.value.split(':');
          return moment().hour(hours).minute(minutes).format();
        }
        return undefined;
      },
      set(value) {
        if (!this.disabled) {
          const date = moment(value);
          const hours = date.hour();
          const minutes = date.minute();

          this.$emit('input', `${String(hours).padStart(2, 0)}:${String(minutes).padStart(2, 0)}`);
        }
      },
    },
    formattedDate() {
      if (this.value === '') {
        return formatSingleDateToDatepicker(Date.now(), this.format);
      }
      return this.type === 'monthrange'
        ? formatRangeDateToDatepicker(this.value)
        : formatSingleDateToDatepicker(this.value, this.format);
    },
  },
  methods: {
    onClick() {
      if (!this.isOpen) {
        return this.$refs.timepicker.focus();
      }
      return this.handleClosePopup();
    },
    handleClosePopup() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.custom-timepicker {
  flex: 1;
  position: relative;
}

.timepicker-icon {
  position: absolute;
  right: rem(8);
  top: rem(19);
  z-index: 50;
  font-size: rem(18);
}

.original-picker {
  width: auto;

  ::v-deep input {
    padding-left: rem(10);
    font-family: $font-family-regular;
    font-size: rem(14);
    height: rem(28);
  }

  ::v-deep .el-input__prefix {
    display: none;
  }
}

label {
  display: block;
  color: var(--text-secondary);
  font-family: $font-family-regular;
  font-size: rem(10);
  letter-spacing: rem(0.8);
  line-height: rem(10);
  margin-bottom: rem(5);
  text-transform: uppercase;
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';
.time-range{
  width: fit-content;
}
.original-picker{
  input {
    width: rem(140);
  }
}
.custom-timepicker {
  .timepicker-icon {
    font-size: rem(16);
    top: rem(18);
  }
}
.el-picker-panel {
  &__content {
    .el-month-table {
      font-family: $font-family-regular;
      font-size: rem(14);
      line-height: rem(18);
    }
    .el-date-table {
      font-family: $font-family-regular;
      font-size: rem(14);
      line-height: rem(18);
    }
    .el-date-range-picker {
      &__header div {
        font-family: $font-family-regular;
        font-size: rem(18);
        line-height: rem(24);
      }
    }
  }
}
</style>
